const pt = {
  home: {
    helloworld: 'Olá, 🌎!',
    reachout: 'Entre em contato!',
  },
  footer: {
    copyright: '© 2025 Adriano Vieira. Todos os direitos reservados.',
  },
}

export default pt
